import { goTo } from "@/lib/scroll";

export default function Logo({ variant = "horizontal" }) {
  const isVertical = variant === "vertical";
  return (
    <a href="#top" onClick={goTo("#top")} data-testid="logo-link" className="inline-block">
      <img
        src={isVertical ? "img/logo-vertical.png" : "img/logo-horizontal.png"}
        alt="Mariane Prado — Neurologia"
        className={isVertical ? "h-28 md:h-32 w-auto" : "h-10 md:h-12 w-auto"}
      />
    </a>
  );
}
